import { ReactNode } from 'react'
import useMediaQueryHook from 'src/hooks/useMediaQuery.hook'
import styled, { css } from 'styled-components'
import { COLOR } from 'src/constants/colors'

export type SpanPropsType = {
  children?: ReactNode
  onClick?: (e: React.MouseEvent<HTMLSpanElement>) => void
  color?: string
  width?: string
  $margin?: string
  padding?: string
  fontSize?: string
  $line_height?: string
  fontWeight?: string
  fontFamily?: string
  $text_align?: string
  display?: string
  $align_items?: string
  ellipsis?: number | 'unset'
  className?: string
  style?: Object
  $whitespace?: string
  option?:
    | 'mini'
    | 'tiny'
    | 'small'
    | 'medium'
    | 'mediumLarge'
    | 'Large'
    | 'extraLarge'
    | 'huge'
    | 'mini_bold'
    | 'tiny_bold'
    | 'small_bold'
    | 'medium_bold'
    | 'mediumLarge_bold'
    | 'Large_bold'
    | 'extraLarge_bold'
    | 'huge_bold'
    | 'title'
    | 'desc'
}

const Span = (props: SpanPropsType) => {
  const { setMediaStyle } = useMediaQueryHook()

  const SpanOptionStyle = {
    mini: {
      fontSize: '12px',
      line_height: '17px',
      fontFamily: 'NotoSansRegular',
      text_align: 'center',
    },
    mini_bold: {
      fontSize: '12px',
      line_height: '17px',
      fontFamily: 'NotoSansBold',
      text_align: 'center',
    },
    tiny: {
      fontSize: '14px',
      line_height: '20px',
      fontFamily: 'NotoSansRegular',
      text_align: 'center',
    },
    tiny_bold: {
      fontSize: '14px',
      line_height: '20px',
      fontFamily: 'NotoSansBold',
      text_align: 'center',
    },
    small: {
      fontSize: '16px',
      line_height: '23px',
      fontFamily: 'NotoSansRegular',
      text_align: 'center',
    },
    small_bold: {
      fontSize: '16px',
      line_height: '23px',
      fontFamily: 'NotoSansBold',
      text_align: 'center',
    },
    medium: {
      fontSize: '18px',
      line_height: '26px',
      fontFamily: 'NotoSansRegular',
      text_align: 'center',
    },
    medium_bold: {
      fontSize: '18px',
      line_height: '26px',
      fontFamily: 'NotoSansBold',
      text_align: 'center',
    },
    mediumLarge: {
      fontSize: '20px',
      line_height: '28px',
      fontFamily: 'NotoSansRegular',
      text_align: 'center',
    },
    mediumLarge_bold: {
      fontSize: '20px',
      line_height: '28px',
      fontFamily: 'NotoSansBold',
      text_align: 'center',
    },
    Large: {
      fontSize: '22px',
      line_height: '32px',
      fontFamily: 'NotoSansRegular',
      text_align: 'center',
    },
    Large_bold: {
      fontSize: '22px',
      line_height: '32px',
      fontFamily: 'NotoSansBold',
      text_align: 'center',
    },
    extraLarge: {
      fontSize: '24px',
      line_height: '35px',
      fontFamily: 'NotoSansRegular',
      text_align: 'center',
    },
    extraLarge_bold: {
      fontSize: '24px',
      line_height: '35px',
      fontFamily: 'NotoSansBold',
      text_align: 'center',
    },
    huge: {
      fontSize: '28px',
      line_height: '41px',
      fontFamily: 'NotoSansRegular',
      text_align: 'center',
    },
    huge_bold: {
      fontSize: '28px',
      line_height: '41px',
      fontFamily: 'NotoSansBold',
      text_align: 'center',
    },
    title: {
      fontSize: setMediaStyle('24px', '20px', '20px'),
      line_height: setMediaStyle('35px', '28px', '28px'),
      fontFamily: 'NotoSansBold',
      text_align: 'left',
    },
    desc: {
      fontSize: setMediaStyle('14px', '12px', '12px'),
      line_height: setMediaStyle('20px', '20px', '17px'),
      fontFamily: 'NotoSansRegular',
      text_align: 'left',
    },
  }

  return (
    <SpanWrap
      fontSize={props.option ? SpanOptionStyle[props.option]?.fontSize : props.fontSize}
      fontFamily={props.option ? SpanOptionStyle[props.option]?.fontFamily : props.fontFamily}
      $line_height={props.option ? SpanOptionStyle[props.option]?.line_height : props.$line_height}
      $text_align={props.option ? SpanOptionStyle[props.option]?.text_align : props.$text_align}
      onClick={props.onClick}
      {...props}
    >
      {props.children}
    </SpanWrap>
  )
}
export default Span

const SpanWrap = styled.span<SpanPropsType>`
  display: ${(props) => props.display || 'inline-block'};
  color: ${(props) => props.color || COLOR.black100};
  margin: ${(props) => props.$margin || '0'};
  text-align: ${(props) => props.$text_align || 'center'};
  width: ${(props) => props.width || '100%'};
  font-size: ${(props) => props.fontSize || '14px'};
  padding: ${(props) => props.padding || '0'};
  line-height: ${(props) => props.$line_height};
  font-family: ${(props) => props.fontFamily || 'NotoSansRegular'}, serif !important;
  cursor: ${(props) => (props.onClick ? 'pointer' : 'unset')};
  align-items: ${(props) => props.$align_items};
  white-space: ${(props) => props.$whitespace || 'unset'};
  ${(props) =>
    props.ellipsis &&
    css`
      overflow-wrap: break-word;
      overflow: hidden;
      -webkit-line-clamp: ${props.ellipsis};
      text-overflow: ellipsis;
      display: -webkit-box !important;
      -webkit-box-orient: vertical;
    `}
`
